export default __webpack_public_path__ + "orange-icon-vr.png";